import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from './cn';

/** Numéro sénégalais par défaut (`7X XXX XX XX`) ; un numéro international (+33…) reste accepté. */
export const PhoneInput = forwardRef<HTMLInputElement, Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>>(function PhoneInput({ className, ...rest }, ref) {
  return (
    <div className="flex h-14 items-center gap-2.5 rounded-xl border border-sand-300 bg-white px-4 focus-within:border-brand-800 focus-within:ring-2 focus-within:ring-gold-500/60">
      <span className="border-r border-sand-200 pr-2.5 text-base font-bold text-gray-600" aria-hidden="true">
        SN +221
      </span>
      <input
        ref={ref}
        type="tel"
        inputMode="tel"
        autoComplete="tel-national"
        placeholder="77 123 45 67"
        className={cn('min-w-0 flex-1 border-0 bg-transparent p-0 text-[17px] font-semibold text-ink placeholder:font-normal focus:outline-none focus:ring-0', className)}
        {...rest}
      />
    </div>
  );
});
